module.exports = __webpack_public_path__ + "public/img/topBg.df21d744.png";